var hosts = 'https://admin.styleoa.com/';
export default{
	//合作商
    hosts: hosts,
	//单张图片上传
	single_upload: hosts+'api/common/single_upload',
	//登录接口
	login: hosts+'api/Account/login',
	//首页轮播图接口
	advertisement: hosts+'api/index/advertisement',
	//首页快报接口
	fastnotice: hosts+'api/index/noticelist',
	//notice读
	readnotice: hosts+'api/index/readnotice',
	//首页资讯分类
	newscate: hosts+'api/news/category',
	//首页获取分类列表
	newslist: hosts+'api/PcSupplier/newsdata',
	//首页资讯详情
	newsdetail: hosts+'api/news/detail',
	//合作商信息更新
	updateinfo: hosts+'api/supplier/updateinfo',
	//合作商密码修改
	updatepassword: hosts+'api/supplier/updatepassword',
	//合作商订单列表
	supplier_order_list: hosts+'api/PcSupplier/supplier_order_list',
	//合作商项目分类
	procate: hosts+'api/project/category',
	//合作商项目列表
	prolist: hosts+'api/project/list',
	//合作商添加订单
	supplier_create: hosts+'api/order/supplier_create',
	//合作商商户列表
	account_list: hosts+'api/supplier/account_list',
	//合作商修改账户
	save_account: hosts+'api/supplier/save_account',
	//合作商删除收款账户
	del_account: hosts+'api/supplier/del_account',
	//合作商账户信息
	account: hosts+'api/supplier/account',
	//合作商订单操作
	supplierOrderHandle: hosts+'/api/order/supplierOrderHandle',
	//合作商订单详情
	order_detail: hosts+'api/order/supplierOrder',
	//合作商获取技师详情
	getstaffdetail: hosts+'api/common/staff_archives',
	//合作商获取客户列表
	customer_list: hosts+'api/PcSupplier/customer_list',
	//合作商获取客户详情
	customer_info: hosts+'api/supplier/customer_info',
	//合作商添加编辑客户
	save_customer: hosts+'api/supplier/save_customer',
	//合作商删除客户
	del_customer: hosts+'api/supplier/del_customer',
	//合作商意见反馈
	feedback: hosts+'api/supplier/feedback',
	//合作商平台介绍
	introduction: hosts+'api/common/introduction',
	//技师评论列表
	comment_list: hosts+'api/common/comment_list',
	//技师平评论点赞
	like_comment: hosts+'api/supplier/like_comment',
	//技师评价模型
	evaluate: hosts+'api/order/evaluate',
	//技师保存
	save_comment: hosts+'api/order/save_comment',
	//技师评论数量
	comment_type_num: hosts+'api/common/comment_type_num',
	//商户余额记录
	achievement: hosts+'api/PcSupplier/achievement',
	//退出登录
	loginout: hosts+'api/Account/loginout',
  //合作商个人信息
  information: hosts+'api/PcSupplier/information',
  //合作商今日消息
  date_notice: hosts+'api/PcSupplier/date_notice',
  //合作商销售额
  sales_data: hosts+'api/PcSupplier/sales_data',
  //合作商总提成
  catesales: hosts+'api/PcSupplier/catesales',
  //合作商提成
  achievement_data: hosts+'api/PcSupplier/achievement_data',
  //平台二维码
  qrcode: hosts+'api/PcSupplier/kefu_code',
  //获取资讯分类
  newsCat: hosts+'api/PcSupplier/newsCat',
  //获取资讯列表
  newsList: hosts+'api/PcSupplier/newsList',
}



// WEBPACK FOOTER //
// ./src/public/parms.js